export default class StartListItem {
  constructor(private readonly _startNumber: number,
              private readonly _headNumber: number,
              private readonly _startHour: number,
              private readonly _startMinutes: number,
              private readonly _rider: string,
              private readonly _horse: string,
              private readonly _clubName: string) {
  }

  get id(): string {
    return this.startNumber + ";" + this.rider + ";" + this.horse;
  }

  get startNumber(): number {
    return this._startNumber;
  }

  get headNumber(): number {
    return this._headNumber;
  }

  get startHour(): number {
    return this._startHour;
  }

  get startMinutes(): number {
    return this._startMinutes;
  }

  get rider(): string {
    return this._rider;
  }

  get horse(): string {
    return this._horse;
  }

  get clubName(): string {
    return this._clubName;
  }
}
